// components/SEO.js
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  image,
  url,
  keywords,
  robots = "index, follow",
}) => {
  const siteUrl = "https://www.symforklifts.com";
  const pageUrl = url ? url : window.location.href;

  // Combine site URL with relative path if needed
  const fullUrl =
    url && !url.startsWith("http")
      ? `${siteUrl}${url.startsWith("/") ? url : "/" + url}`
      : pageUrl;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="SYM Machinery" />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:url" content={fullUrl} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      {/* Canonical */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
